var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 20H7.99977M15.9998 7C15.9998 5.4087 15.3676 3.88258 14.2424 2.75736C13.1172 1.63214 11.5911 1 9.99977 1C8.40848 1 6.88235 1.63214 5.75713 2.75736C4.63192 3.88258 3.99977 5.4087 3.99977 7C3.99977 10.0902 3.22024 12.206 2.34944 13.6054C1.6149 14.7859 1.24763 15.3761 1.2611 15.5408C1.27601 15.7231 1.31463 15.7926 1.46155 15.9016C1.59423 16 2.19237 16 3.38863 16H16.6109C17.8072 16 18.4053 16 18.538 15.9016C18.6849 15.7926 18.7235 15.7231 18.7384 15.5408C18.7519 15.3761 18.3846 14.7859 17.6501 13.6054C16.7793 12.206 15.9998 10.0902 15.9998 7Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.46fbfccfc9904ef7497f650e8c262920.svg";
export { ForwardRef as ReactComponent };